var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSafe = function SvgSafe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 4c-1.093 0-2 .907-2 2v12c0 1.093.907 2 2 2v1h2v-1h12v1h2v-1c1.093 0 2-.907 2-2V6c0-1.093-.907-2-2-2zm0 2h16v12H4zm7.457 2.043-1.414 1.414 1.26 1.26A2.95 2.95 0 0 0 11 12c0 .46.114.892.303 1.283l-1.26 1.26 1.414 1.414 1.26-1.26c.391.189.823.303 1.283.303s.892-.114 1.283-.303l1.26 1.26 1.414-1.414-1.26-1.26c.189-.391.303-.823.303-1.283s-.114-.892-.303-1.283l1.26-1.26-1.414-1.414-1.26 1.26A2.95 2.95 0 0 0 14 9c-.46 0-.892.114-1.283.303zM6 9v6h2V9zm8 2c.564 0 1 .436 1 1s-.436 1-1 1-1-.436-1-1 .436-1 1-1"
  })));
};
export default SvgSafe;